<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Upload"></app-page-title>
        <form [formGroup]="tatForm">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="chargetype" class="form-label">TAT Type<span class="mandatory">
                                                *</span></label>
                                        <ng-select id="chargetype" placeholder="Select" [items]="tatTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlTatType" [bindValue]="'id'"
                                            bindLabel="tattype" (change)="onChangeTatType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('ddlTatType')?.dirty) && tatForm.get('ddlTatType').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || tatForm.get('ddlTatType')?.dirty) && tatForm.get('ddlTatType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="tatForm.get('ddlTatType').errors.required">TAT Type
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="showContract">
                                    <div class="mb-2">
                                        <label for="chargeCategoryType" class="form-label">Contract Type<span
                                                *ngIf="isContarctTypeMand" class="mandatory">*</span></label>
                                        <ng-select id="chargeCategoryType" placeholder="Select" [items]="contractTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlContractType" bindLabel="tatcategory"
                                            [bindValue]="'id'" (change)="onChangeContractType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('ddlContractType')?.touched) && tatForm.get('ddlContractType').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || tatForm.get('ddlContractType')?.touched) && tatForm.get('ddlContractType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="tatForm.get('ddlContractType').errors.required">Contract
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="showCustomer">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="customerCharge" class="form-label">Customer<span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="customerCharge" [items]="customerList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                formControlName="ddlCustomer"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('ddlCustomer')?.touched) && tatForm.get('ddlCustomer').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || tatForm.get('ddlCustomer')?.touched) && tatForm.get('ddlCustomer').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="tatForm.get('ddlCustomer').errors.required">Customer
                                                    is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showDownloadBtn">
                                    <div class="col-md-2">
                                        <label class="form-label mb-0"></label>
                                        <div class="">
                                            <button type="button" class="btn btn-primary btn-sm"
                                                (click)="downloadFormatFile()">
                                                <i class="bx bx-download font-size-16 align-middle me-2"></i> Download
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
    
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="fromDate" class="form-label">From Date <span
                                                class="mandatory">*</span></label>
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate" max="9999-12-31"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('txtFromDate')?.touched) && tatForm.get('txtFromDate').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                        <div *ngIf="(isFormSubmitted || tatForm.get('txtFromDate')?.touched) && tatForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="tatForm.get('txtFromDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="toDate" class="form-label">To Date <span
                                                class="mandatory">*</span></label>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate" max="9999-12-31"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('txtToDate')?.touched) && tatForm.get('txtToDate').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                        <div *ngIf="(isFormSubmitted || tatForm.get('txtToDate')?.touched) && tatForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="tatForm.get('txtToDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">( <small
                                        for=""><i class="mdi mdi-information">Note: xls are only allowed.</i></small> )</label>
                                    <div class="input-group">
                                        <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls"
                                            id="importtat"
                                            formControlName="fileControl" (change)="onChangeFileSelect($event)"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || tatForm.get('fileControl')?.touched) && tatForm.get('fileControl').errors}" appEnterDirective [onEnterKey]="useEnterKey">
                                        <button type="button" class="btn btn-primary btn-sm"
                                            (click)="uploadTat()" (keydown.enter)="useEnterKey ? $event.preventDefault() : uploadTat()"appEnterDirective [onEnterKey]="useEnterKey">
                                            <i class="bx bx-upload font-size-16 align-middle me-2"></i> Upload
                                        </button>
                                        <div *ngIf="(isFormSubmitted || tatForm.get('fileControl')?.touched) && tatForm.get('fileControl').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="tatForm.get('fileControl').errors.required">Select file to
                                                upload</span>
                                        </div>
                                    </div>
                                    <div *ngIf="showProgressBar" class="progress mt-2">
                                        <div class="progress-bar progress-bar-striped" role="progressbar"
                                            [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0"
                                            aria-valuemax="100">
                                            {{progress}}%
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">TAT LIST</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowDataTAT" [columnDefs]="columnDefsPeriod" [animateRows]="true"
                                [context]="context" [defaultColDef]="defaultColDef" [suppressMenuHide]="true"
                                [pagination]="true" (gridReady)="onGridReadyPeriod($event)"
                                [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">TAT INFO LIST</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowDataTATInfo" [columnDefs]="columnDefs" [animateRows]="true"
                                [context]="context" [defaultColDef]="defaultColDef" [suppressMenuHide]="true"
                                [pagination]="true" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>